export default "__VITE_ASSET__6c001ddb__"